var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4ZM2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12ZM17.1644 8.75259C17.5771 9.11951 17.6143 9.75158 17.2474 10.1644L11.9141 16.1644C11.7243 16.3779 11.4523 16.5 11.1667 16.5C10.881 16.5 10.609 16.3779 10.4193 16.1644L7.75259 13.1644C7.38567 12.7516 7.42285 12.1195 7.83564 11.7526C8.24842 11.3857 8.88049 11.4229 9.24741 11.8356L11.1667 13.9948L15.7526 8.83564C16.1195 8.42285 16.7516 8.38567 17.1644 8.75259Z",
    fill: "#1C8747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCheck);
export default __webpack_public_path__ + "static/media/icon_circle-check.4880deaf8960233161a4528f5d8ee39b.svg";
export { ForwardRef as ReactComponent };